import {
  Box,
  Button,
  FormHelperText,
  Typography,
  useTheme,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import OTPInput from 'src/components/common/form/OTPInput';
import {
  CenteredContentContainer,
  FlexColumnContainer,
} from 'src/components/styles';
import { useAmplitude } from 'src/context/AmplitudeProvider';
import { EventNamesMap } from 'src/context/AmplitudeProvider';

interface VerificationOtpInputProps {
  onSubmit?: (otp: string) => void;
  onResendCode: () => void;
  enableRequestNewCode: boolean;
  timeToResend: string;
  isError: boolean;
  isPending: boolean;
  to: string;
}

export default function VerificationOtpInput({
  enableRequestNewCode,
  isError,
  isPending,
  onResendCode,
  onSubmit,
  timeToResend,
  to,
}: VerificationOtpInputProps) {
  const theme = useTheme();
  const [otp, setOtp] = useState('');
  const otpRef = useRef<string>(otp);
  const { logEvent } = useAmplitude();
  const handleOtpChange = (value: string) => {
    setOtp(value);
    logEvent(EventNamesMap.PhoneOtpFieldChanged, {
      otp: value,
    } as never);
  };

  useEffect(() => {
    if (onSubmit && otp.length === 6 && !isPending && otp !== otpRef.current) {
      logEvent(EventNamesMap.PhoneOtpFieldCompleted, {} as never);
      logEvent(EventNamesMap.PhoneOtpVerificationSubmitted, {} as never);
      onSubmit(otp);
    }

    otpRef.current = otp;
  }, [otp, isPending]);

  return (
    <>
      <FlexColumnContainer minHeight={85}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Typography
            variant="h5"
            textAlign="center"
            fontWeight="fontWeightMedium"
            mb={2}
          >
            Ingresa el código que enviamos a {to}
          </Typography>
        </Box>
        <OTPInput
          value={otp}
          onChange={handleOtpChange}
          isError={isError}
          errorStyle={{
            borderColor: theme.palette.error.main,
          }}
          inputStyle={{
            width: '42px',
            height: '50px',
            padding: '0',
          }}
        />

        {isError && (
          <FormHelperText error sx={{ px: 1.8, pb: 0.4, textAlign: 'center' }}>
            El código ingresado es incorrecto
          </FormHelperText>
        )}
      </FlexColumnContainer>
      <CenteredContentContainer>
        <Button
          disabled={!enableRequestNewCode}
          onClick={onResendCode}
          sx={{ mt: 'auto' }}
          variant={'text'}
        >
          {`No recibí el código ${
            enableRequestNewCode ? '' : `(${timeToResend})`
          }`}
        </Button>
      </CenteredContentContainer>
    </>
  );
}
